import { useEffect } from 'react';
import Lenis from 'lenis';
import prefersReducedMotion, { hasFinePointer } from './prefersReducedMotion';

/**
 * Momentum scrolling on desktop pointers only (touch scrolling is already
 * smooth; reduced-motion users get native scrolling). Exposes the instance
 * on window.__pnpLenis so in-page links can use it.
 */
export default function SmoothScroll() {
  useEffect(() => {
    if (prefersReducedMotion() || !hasFinePointer()) return undefined;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__pnpLenis = lenis;
    let raf = 0;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    document.documentElement.classList.add('lenis-on');
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__pnpLenis === lenis) delete window.__pnpLenis;
      document.documentElement.classList.remove('lenis-on');
    };
  }, []);
  return null;
}

/** Smooth-scrolls to an element id, through Lenis when it's running. */
export function scrollToId(id, { immediate = false } = {}) {
  const el = document.getElementById(id);
  if (!el) return false;
  const lenis = window.__pnpLenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: -84, immediate });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY - 84;
    window.scrollTo({ top, behavior: immediate || prefersReducedMotion() ? 'auto' : 'smooth' });
  }
  return true;
}
